export default __webpack_public_path__ + "static/media/RatTunnel.6a49e52e.png";